// extracted by mini-css-extract-plugin
export default {"lastEdit":"lastEdit_lastEdit__40sbz"};